"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ruleValidator = require("./ruleValidator");

var _validationRules = require("../../constants/validation/validationRules");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var validateField = function validateField(fieldData) {
  var name = fieldData.name,
      rules = fieldData.rules,
      value = fieldData.value;

  if (!name || !rules.length) {
    if (!name) {
      console.error('Please include an input name attribute for input validation.'); // eslint-disable-line no-console
    }

    return _objectSpread(_objectSpread({}, fieldData), {}, {
      errors: []
    });
  }

  var validationMessages = rules.map(function (rule) {
    return (0, _ruleValidator.validateRule)(rule, value, name);
  }).filter(function (validationString) {
    return validationString;
  });
  return _objectSpread(_objectSpread({}, fieldData), {}, {
    errors: validationMessages
  });
};

var inputValidator = function inputValidator(fieldData) {
  var fieldDataKeys = Object.keys(fieldData); // console.log(fieldData);

  if (fieldDataKeys.length < 1) {
    console.error('Input Validation requires input to be within a collection'); // eslint-disable-line no-console

    return _objectSpread(_objectSpread({}, fieldData), {}, {
      errors: []
    });
  } // fields that are not marked as required should not have validation rules run when the fields are empty


  if (fieldData.value.length <= 0 && !fieldData.rules.includes(_validationRules.REQUIRED)) {
    return _objectSpread(_objectSpread({}, fieldData), {}, {
      errors: []
    });
  }

  return validateField(fieldData);
};

var _default = inputValidator;
exports.default = _default;